import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6950852e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=6950852e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950852e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6950852e')) {
      api.createRecord('6950852e', component.options)
    } else {
      api.reload('6950852e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6950852e&scoped=true", function () {
      api.rerender('6950852e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appcoupons/index.vue"
export default component.exports